import axios from "axios";
import { GET_REQUESTS } from "../utilities/constants";

export const getRequests = async (dispatch) => {
  const { data } = await axios.get("/api/partnerrequest/");
  dispatch({ type: GET_REQUESTS, payload: data.data });
};
